function isInUsersPage() {
  return $("#usersPage").length > 0;
}

if (isInUsersPage()) {
  var accessColumn = [];
  $("#accessGroupTable tbody tr")
    .find("td:eq(0)")
    .each(function (index, value) {
      accessColumn.push($(this).html());
    });

  $("#accessGroup option")
    .not(":first-child")
    .each(function (value, index) {
      var currentText = $(this).text();
      if (accessColumn.includes(currentText)) {
        $(this).remove();
      }
    });

  $("#addAccessGroup").click(function () {
    $("#tableValidation").text("");
    var classification = $("#accessGroup").val();
    if (classification != "") {
      var accessGroupText = $("#accessGroup option:selected").html();
      var accessGroup = "datamart-delta-" + accessGroupText;
      var tdAccessName = $("<td class=\"govuk-table__cell\">" + accessGroupText + "</td>");
      var tdClassification = $("<td class=\"govuk-table__cell\">" + classification + "</td>");
      var notAbleTodAddRow = accessColumn.includes(accessGroupText);

      if (!notAbleTodAddRow) {
        var tdAccessId = $(
          "<td class=\"govuk-table__cell\">\
              <input class=\"govuk-checkboxes\" type=\"checkbox\" value=\"" + accessGroup + "\" name=\"accessGroups\"/>\
           </td>"
        );
        tdAccessId.find("input").prop("checked", true);

        var tdAccessDelegates = $(
          "<td class=\"govuk-table__cell\">\
              <input class=\"govuk-checkboxes\" type=\"checkbox\" value=\"" + accessGroup + "\" name=\"accessGroupDelegates\"/>\
           </td>",
        );

        var selectedOptions = $("#addAccessGroupTable tbody tr:first")
          .find("td:eq(2)")
          .find("select")
          .val();
        var sampleRow = $("#addAccessGroupTable tbody tr:first").clone();
        var td1 = sampleRow.find("td:eq(1)");

        var selectNameAttr = "accessGroupOrganisations[" + accessGroup + "]";
        var selectField = sampleRow
          .find("td:eq(2)")
          .find("select")
          .attr("name", selectNameAttr);
        selectField.val(selectedOptions);
        selectField.trigger("chosen:updated");

        var td4 = $("<td class=\"govuk-table__cell\"></td>").append(selectField);

        var tr = $("<tr class=\"govuk-table__row\"></tr>")
          .append(tdAccessName)
          .append($(td1[0]))
          .append(tdAccessId)
          .append(tdAccessDelegates)
          .append(td4);

        $("#accessGroupTable tbody").append(tr);
        accessColumn.push(accessGroupText);
        $("#accessGroup option[text=" + accessGroupText + "]").remove();
        //                $("#accessGroup option:contains(" + accessGroupText + ")").remove();
        $(".js-option-consumer").chosenSelect();
      }
    }

    resetTfoot();
  });
  $("#accessGroup").on("change", function () {
    var accessGroupVal =
      "datamart-delta-" + $("#accessGroup option:selected").html();
    var classification = $(this).val();
    $("#addAccessGroupTable tbody tr:first")
      .find("td:eq(1)")
      .text(classification);
    //            $("#addAccessGroupTable tr").find("td:eq(2)").each(function(index, value) {
    //                var check1 = $(this).find('input');
    //                check1.attr("value", accessGroupVal);
    //            });
    //            $("#addAccessGroupTable tr").find("td:eq(3)").each(function(index, value) {
    //                var check2 = $(this).find('input');
    //                check2.attr("value", accessGroupVal);
    //            });
  });

  function resetTfoot() {
    $("#accessGroup").val("").trigger("chosen:updated");
    $("#addAccessGroupTable tbody tr:first").find("td:eq(1)").text("");
    //            var accessCheckBox = $("#addAccessGroupTable tr:first").find('td:eq(2)').find('input');
    //            accessCheckBox.val("");
    //            accessCheckBox.prop('checked', false);
    //            var delegateCheckBox = $("#addAccessGroupTable tr:first").find('td:eq(3)').find('input');
    //            delegateCheckBox.val("");
    //            delegateCheckBox.prop('checked', false);
    var orgSelect = $("#addAccessGroupTable tbody tr:first")
      .find("td:eq(2)")
      .find("select");
    orgSelect.attr("name", "");
    orgSelect.val("").trigger("chosen:updated");
  }
}
